import { MutableRefObject } from 'react';

import { isValid } from 'date-fns';

function assertRefIsNotNull<T>(ref: MutableRefObject<T | null | undefined>): asserts ref is {
  current: T;
} {
  if (ref.current === null) {
    throw new Error('Ref object is null');
  }
}

function assertIsDate(date: unknown): asserts date is Date {
  if (!date || !isValid(date)) {
    throw new Error('Date is not a "Date" instance!');
  }
}

function assertIsNotUndefined<T>(unknown: T | undefined): asserts unknown is T {
  if (unknown === undefined) {
    throw new Error('Object is undefined!');
  }
}

function assertIsNotUndefinedNorNull<T>(unknown: unknown): asserts unknown is Exclude<T, null | undefined> {
  if (unknown === undefined || unknown === null) {
    throw new Error('Object is undefined or null!');
  }
}

function assertErrorHasResponse<T>(unknown: unknown): asserts unknown is {
  response: T;
} {
  if (!unknown || (unknown as { response: T }).response === undefined) {
    throw new Error('Object has no response');
  }
}

function assertErrorHasData<T>(unknown: unknown): asserts unknown is {
  data: T;
} {
  if (!unknown || (unknown as { data: T }).data === undefined) {
    throw new Error('Object has no data');
  }
}

function assertObjectIsTruthy<T>(unknown: unknown): asserts unknown is T {
  if (!unknown) {
    throw new Error('Object is not truthy');
  }
}

function assertErrorIsError(unknown: unknown): asserts unknown is Error {
  if (!(unknown instanceof Error)) {
    throw new Error('Error is not an error');
  }
}

export {
  assertRefIsNotNull,
  assertIsDate,
  assertIsNotUndefined,
  assertErrorHasResponse,
  assertErrorHasData,
  assertObjectIsTruthy,
  assertIsNotUndefinedNorNull,
  assertErrorIsError,
};
